"use client";

import { Globe2, KeyRound, ShieldCheck, Zap } from "lucide-react";
import { PopText, Reveal } from "@/components/motion/reveal";
import { FeatureList } from "@/components/landing/beats/feature-list";
import { CrossChainConstellation } from "@/components/landing/cross-chain-constellation";
import { GradientText } from "@/components/ui/gradient-text";
import { Spotlight } from "@/components/ui/spotlight";

const FEATURES = [
  { icon: Globe2, text: "20+ chains, one unified balance" },
  { icon: Zap, text: "Swap across chains in a single tap" },
  { icon: ShieldCheck, text: "No bridges, no wrapped tokens" },
  { icon: KeyRound, text: "No seed phrases — one secure login" },
];

export function CrossChain() {
  return (
    <section id="cross-chain" className="relative overflow-hidden px-4 py-16 sm:py-20">
      <Spotlight fill="rgba(124,58,237,0.18)" className="left-1/2 top-0 -translate-x-1/2" />
      <div className="mx-auto grid max-w-6xl items-center gap-12 lg:grid-cols-2">
        <Reveal className="text-center lg:text-left">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">Cross-chain</p>
          <h2 className="mt-3 text-balance text-4xl font-semibold tracking-tight sm:text-5xl">
            <PopText className="block">Every chain.</PopText>
            <PopText className="block" delay={0.18}>
              <GradientText>One wallet.</GradientText>
            </PopText>
          </h2>
          <p className="mt-4 hidden max-w-lg text-lg text-muted-foreground md:block">
            Hold, swap, and spend across every chain from a single wallet. We find the route and
            settle under the hood — you just tap. No bridges, ever.
          </p>
          <FeatureList className="mt-8" features={FEATURES} />
        </Reveal>

        <Reveal delay={0.1}>
          <CrossChainConstellation />
        </Reveal>
      </div>
    </section>
  );
}
